const apis = {
    post_save_company: "/signin",
    API_GET_ALL_LOCATIONS: "/admin/ubicacionGeografica/unificada",
}

export default apis;